import DepartmentListWithCounts from './Request/Department_listWithCounts';

const mapDepartmentList = departmentlist => {
  return departmentlist.map(department => [
    department.name,
    department.numberOfEmployees,
    department.numberOfCourses,
    department.id,
  ]);
};

const DepartmentsList = async () => {
  const departments = await DepartmentListWithCounts();
  const departmentsList = mapDepartmentList(departments);
  return { departmentsList };
};

export default DepartmentsList;
